import { defineStore } from 'pinia';
import { ErrorType, ToastItem } from '@/types/utils/toast.types';

export const useToastStore = defineStore('toast', {
  state: () => ({
    toasts: [] as ToastItem[],
  }),
  actions: {
    showToast(
      type: ErrorType,
      title: string,
      description?: string,
      timeout?: number,
      persistent: boolean = false,
    ): void {
      // Success toasts auto-dismiss faster (3s) than other types (5s) unless an
      // explicit timeout is provided by the caller.
      const resolvedTimeout = timeout ?? (type === 'success' ? 3000 : 5000);

      this.toasts.push({
        id: crypto.randomUUID(),
        type,
        title,
        description,
        timeout: resolvedTimeout,
        persistent,
      });
    },
    togglePinToast(id: string, savedRemaining?: number): void {
      const index = this.toasts.findIndex((t) => t.id === id);
      const toast = index === -1 ? undefined : this.toasts[index];
      if (toast) {
        this.toasts[index] = toast.persistent
          ? { ...toast, persistent: false }
          : { ...toast, persistent: true, savedRemaining };
      }
    },
    removeToast(id: string): void {
      this.toasts = this.toasts.filter((t) => t.id !== id);
    },
  },
});
